/**
 * TopicKeyTopics - Compact key topics list (non-clickable, max 4)
 */

import { Lightbulb } from "lucide-react";

interface TopicKeyTopicsProps {
    topics: string[];
}

export const TopicKeyTopics = ({ topics }: TopicKeyTopicsProps) => {
    if (!topics || topics.length === 0) return null;

    const displayTopics = topics.slice(0, 4);

    return (
        <div className="bg-white border border-slate-200 shadow-sm rounded-xl p-5 mb-8">
            {/* Header */}
            <div className="flex items-center gap-2 mb-3">
                <Lightbulb className="w-4 h-4 text-amber-500" />
                <h3 className="text-sm font-semibold text-slate-900 tracking-tight">
                    Key Topics
                </h3>
            </div>

            {/* Compact List with Icons */}
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2">
                {displayTopics.map((topic, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-slate-600">
                        <span className="mt-1 block w-1.5 h-1.5 rounded-full bg-slate-300 flex-shrink-0" />
                        <span className="leading-relaxed">{topic}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TopicKeyTopics;
